<template>
  <v-row>
    <v-col>
      <v-card>
        <v-list dense>
          <v-subheader>
            providers
            <v-spacer />
            <v-dialog v-model="dialog.provider" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  fab
                  small
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-plus
                      </v-icon>
                    </template>
                    create new provider
                  </v-tooltip>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">provider</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          :disabled="!!dialog.providerItem.id"
                          v-model="dialog.providerItem.name"
                          label="name"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-file-input
                          v-model="dialog.providerItem.thumbnail"
                          accept=".png,.jpg"
                          label="Click here to select a thumbnail .png file"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialog.provider=false"
                    :disabled="dialog.saving"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    :disabled="dialog.saving"
                    :loading="dialog.saving"
                    @click="addProvider"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-subheader>
          <v-list-item
            v-for="item in providers"
            :key="item.id"
          >
            <v-list-item-icon>
              <v-icon
                v-if="!item.reviews_count && !hasSomeAbilities($constants.ABILITY.INTERN)"
                color="red"
                @click="remove(item.id)"
              >
                mdi-delete
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
              <v-list-item-subtitle v-text="'reviews: ' + item.reviews_count" />
            </v-list-item-content>

            <v-list-item-avatar>
              <v-img
                v-if="item.public_link"
                :src="item.public_link"
              />
            </v-list-item-avatar>

            <v-list-item-icon>
              <v-icon @click="editProviderForm(item)">mdi-upload</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Provider',
  data: () => ({
    providers: [],
    dialog: {
      provider: false,
      saving: false,
      providerItem: {
        id: null,
        name: '',
        thumbnail: null,
      },
    },
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/providers')
      .then((response) => {
        this.providers = response.data;
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    addProvider() {
      const data = new FormData();

      if (this.dialog.providerItem.thumbnail) {
        data.append('thumbnail', this.dialog.providerItem.thumbnail);
      }

      data.append('name', this.dialog.providerItem.name);

      if (this.dialog.providerItem.id) {
        data.append('id', this.dialog.providerItem.id);
      }

      this.$requestHelpers
        .post('api/admin/providers',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
        .then((response) => {
          const index = this.providers.findIndex((x) => x.id === response.data.id);

          if (index !== -1) {
            Object.assign(this.providers[index], response.data);
            this.providers[index].public_link += `?${Date.now()}`;
          } else {
            this.providers.push(response.data);
          }

          this.dialog.provider = false;

          this.setSnack({
            color: 'green',
            text: 'data saved',
          });
        });
    },

    editProviderForm(item) {
      this.dialog.provider = true;
      Object.assign(this.dialog.providerItem, item);
    },

    remove(id) {
      this.$confirm('Are you sure you want to delete this captions provider?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/providers/${id}`)
          .then(() => {
            this.providers = this.providers.filter((e) => e.id !== id);
          });
      });
    },
  },

  watch: {
    dialog: {
      handler() {
        if (!this.dialog.provider) {
          Object.assign(this.dialog.providerItem, {
            id: null,
            name: '',
            thumbnail: null,
          });
        }
      },
      deep: true,
    },
  },
};
</script>
